import React from 'react'
import { CalendarDays } from 'lucide-react'

import { DueStatus } from '@/features/my-work'
import { cn } from '@/utils'

import { formatMyWorkDate } from '../utils/dateUtils'

interface MyWorkDueDateProps {
  dueDate: string | null
  status: DueStatus
}

const getDateStyle = (status: DueStatus) => {
  switch (status) {
    case DueStatus.OVERDUE:
      // shadcn destructive tokens (safe)
      return 'text-error-600'

    case DueStatus.DUE_TODAY:
      // warning tone using Tailwind amber
      return 'text-amber-600'

    case DueStatus.DUE_THIS_WEEK:
      // informational purple
      return 'text-purple-500'

    default:
      return ''
  }
}

export const MyWorkDueDate: React.FC<MyWorkDueDateProps> = ({
  dueDate,
  status,
}) => {
  const formattedDate = formatMyWorkDate(dueDate)

  return (
    <div
      className={cn(
        'flex items-center gap-1 text-sm text-gray-600 font-medium',
        getDateStyle(status)
      )}
    >
      <CalendarDays className="h-4 w-4" />
      <span>{formattedDate}</span>
    </div>
  )
}
